import { Pencil } from "lucide-react";
import { Button } from "react-aria-components";

import { Badge } from "@/components/badge";

import type { MBCReviewData } from "../types";

import { EditableText } from "./EditableText";

type BriefCardProps = {
  brief: MBCReviewData["brief"];
  /** When provided, the variation description becomes editable. */
  onDescriptionSave?: (value: string) => void;
};

function EditPencil({ label }: { label: string }) {
  return (
    <Button
      aria-label={`Edit ${label}`}
      className="cursor-pointer rounded-md p-1 text-fg-quaternary outline-hidden transition-colors hover:bg-bg-primary-hover hover:text-fg-brand-primary"
    >
      <Pencil className="size-4" />
    </Button>
  );
}

export function BriefCard({ brief, onDescriptionSave }: BriefCardProps) {
  return (
    <section className="rounded-xl border border-border-primary bg-bg-primary">
      {/* Title row */}
      <div className="flex items-center gap-3 border-b border-border-secondary px-5 py-4">
        <h2 className="text-xl font-semibold text-text-primary">
          {brief.title}
        </h2>
        <Badge isRounded size="medium" variant="secondary">
          {brief.typeTag}
        </Badge>
        <Button
          aria-label="Edit brief"
          className="ml-auto cursor-pointer rounded-md p-1 text-fg-quaternary outline-hidden transition-colors hover:bg-bg-primary-hover hover:text-fg-brand-primary"
        >
          <Pencil className="size-[18px]" />
        </Button>
      </div>

      {/* Variation + description */}
      <div className="flex flex-col gap-3 px-5 py-5">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-text-primary">
            {brief.variationLabel}
          </h3>
          <EditPencil label="variation" />
        </div>
        <EditableText
          multiline
          onSave={onDescriptionSave}
          placeholder="No description yet"
          value={brief.description}
        />
      </div>
    </section>
  );
}
